export default __webpack_public_path__ + "static/media/bp_hyper.8b13d180.svg";